<template>
  <!-- EDIT BUTTON -->
  <v-tooltip :text="`Edit ${props.descriptiveWord} '${item.name}'`" location="top">
    <template v-slot:activator="{ props }">
      <v-btn
          v-bind="props"
          class="mx-1 border-md "
          size="small"
          rounded
          flat
          height="35px"
          min-width="35px"
          max-width="35px"
          @click.prevent="editItem(false)"
          @auxclick.prevent="editItem(true)"
      ><i class="fas fa-pen text-blue-darken-4" /></v-btn>
    </template>
  </v-tooltip>
</template>

<script setup>
  import {router} from "@inertiajs/vue3";

  const props = defineProps({

    /**
     * Used for the purpose of the tooltip. It's usually a literal like 'Project' or 'KPI'.
     */
    descriptiveWord: {
      type: String,
      required: true
    },

    /**
     * Usually, this prop is referring to a database object. A `Project`, a `KPI`, a `PSI`; stuff like that.
     * In this specific component, it's important that this object has `id` and `name` attributes.
     */
    item: {
      type: Object,
      required: true,
    },

    /**
     * The targeted route of the button. When pressed, the button will send a GET request to this route.
     */
    route: {
      type: String,
      required: true
    }
  });

  function editItem(openInNewWindow) {

    if (openInNewWindow)
      window.open(props.route, '_blank');
    else
      router.get(props.route);
  }

</script>
